import React from "react";
import GenericTable, { Column } from "components/Data/DataDisplays/GenericTable";
import { ParsedSheetRow } from "./useSpreadsheetParser";
import { Typography, Box } from "@mui/material";

interface DataPreviewTableProps {
  data: ParsedSheetRow[];
  columns: string[];
}

const DataPreviewTable: React.FC<DataPreviewTableProps> = ({ data, columns }) => {
  const tableCols: Column<ParsedSheetRow>[] = columns.map((c) => ({
    field: c as keyof ParsedSheetRow,
    label: c,
  }));

  return (
    <>
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <GenericTable<ParsedSheetRow>
          title="Data Preview (first 10 rows)"
          data={data.slice(0, 10)}
          columns={tableCols}
          loading={false}
          enableExport={false}
        />
      </Box>
    </>
  );
};

export default DataPreviewTable;
